import React from 'react';
import { Redirect } from 'react-router-dom';
import { ROUTE_ACTIONS } from './constants';

export const getRedirectForAction = ({
  action,
  code,
  authority,
  country,
  lang,
  applicationsLicensePlate,
  applicationsCode,
  isAuthenticated = true,
}) => {
  if (!action) return null;

  switch (action.toLowerCase()) {
    case ROUTE_ACTIONS.PAYMENT:
      return isAuthenticated ? (
        <Redirect to={code ? `/payments/${code}` : '/payments'} />
      ) : (
        <Redirect to="/public/payment/access" />
      );
    case ROUTE_ACTIONS.CONSULTATION:
      return isAuthenticated ? (
        <Redirect
          to={
            code
              ? `/discussions?name=${encodeURIComponent(code)}`
              : '/discussions'
          }
        />
      ) : (
        <Redirect to="/hello" />
      );
    case ROUTE_ACTIONS.APPLICATIONS: {
      const params = new URLSearchParams();

      if (authority) params.set('authority', authority);
      if (lang) params.set('lang', lang);
      if (country) {
        params.set('country', country);
        if (!lang) params.set('lang', country);
      }
      if (code) params.set('code', code);
      if (applicationsLicensePlate) {
        params.set('applications_license_plate', applicationsLicensePlate);
      }
      if (applicationsCode) params.set('applications_code', applicationsCode);

      const queryString = params.toString();
      return (
        <Redirect
          to={`/public/form-application${
            queryString ? `?${queryString}` : ''
          }`}
        />
      );
    }
    default:
      return null;
  }
};

export const getFallbackRedirect = () => <Redirect to="/home" />;
